import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";
import DocumentLabelsListEntry from "./DocumentLabelsListEntry";
import { withState } from "react-searchkit";

class DocumentLabelsResultsGrid extends Component {
  render() {
    const { currentResultsState } = this.props;

    if (
      currentResultsState &&
      currentResultsState.data &&
      (!currentResultsState.data.hits ||
        currentResultsState.data.hits.length === 0)
    ) {
      return null;
    }

    return (
      <div className="document-labels-results-grid">
        <Grid>
          <Grid.Row columns={2}>
            {currentResultsState?.data?.hits?.map((hit) => (
              <DocumentLabelsListEntry
                key={hit.metadata.pid}
                record={hit}
                selectedDocuments={this.props.selectedDocuments}
                addDocumentToSelection={this.props.addDocumentToSelection}
                removeDocumentFromSelection={
                  this.props.removeDocumentFromSelection
                }
              />
            ))}
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

DocumentLabelsResultsGrid.propTypes = {
  currentResultsState: PropTypes.object,
  selectedDocuments: PropTypes.array.isRequired,
  addDocumentToSelection: PropTypes.func.isRequired,
  removeDocumentFromSelection: PropTypes.func.isRequired,
};

export default withState(DocumentLabelsResultsGrid);
